import React, { lazy, Suspense } from "react";
import { Loader } from "@sicredi/react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import { PAGE } from "#/constants";

const LazyHome = lazy(() => import("#/containers/Home"));
const LazyNotFound = lazy(() => import("#/containers/NotFound"));
const LazyCookiePolicy = lazy(() => import("#/containers/CookiePolicy"));
const LazyPrivacyPolicy = lazy(() => import("#/containers/PrivacyPolicy"));

export const Routes: React.FC = () => (
  <Router basename={process.env.PUBLIC_URL}>
    <Suspense fallback={<Loader show fullScreen />}>
      <Switch>
        <Route exact path={PAGE.ROOT()} component={LazyHome} />
        <Route exact path={PAGE.COOKIE_POLICY()} component={LazyCookiePolicy} />
        <Route exact path={PAGE.PRIVACY_POLICY  ()} component={LazyPrivacyPolicy} />
        <Route path="*" component={LazyNotFound} />
      </Switch>
    </Suspense>
  </Router>
);
